import {
  querySysConfigInfoByKey,
  querySelectDataByOrg
} from '@/api/sys.common'

export default {
  namespaced: true,
  actions: {
    /**
     * 分页查询 时间套餐列表
     */
    querySysConfigInfoByKey ({
      dispatch
    }, {
      vm,
      data
    }) {
      return querySysConfigInfoByKey(data)
        .then(res => {
          return res.data
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    querySelectDataByOrg ({
      dispatch
    }, {
      vm,
      data
    }) {
      return querySelectDataByOrg(data)
        .then(res => {
          return res.data
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }
  }
}
